import Vue from 'vue'
import App from '@/UI/App/App.vue'
import './registerServiceWorker'
import router from '@/Infrastructure/Router'
import store from '@/Infrastructure/Store'
import { i18n } from '@/Infrastructure/Intl/Intl'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import '@/UI/Styles/styles.scss'
import VueSweetalert2 from 'vue-sweetalert2'

const optionsSwall = {
  confirmButtonColor: '#1184b9',
  cancelButtonColor: '#95240B',
  reverseButtons: true,
  cancelButtonText: 'Cancelar',
  confirmButtonText: 'Confirmar'
}

Vue.use(VueSweetalert2, optionsSwall)
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
